import { Expose, plainToInstance, Transform, Type } from 'class-transformer';
import { ChatMessageType, ChatType, OnlineStatus } from '@core/enums';
import { BeautifyArrayOfNumbers, GetUserId } from '@core/utils';
import { SafeUrl } from '@angular/platform-browser';

export class ChatEntity {
  id: number;
  name: string;
  lastName: string;

  @Expose({ name: 'login_status' })
  loginStatus: OnlineStatus;

  type: ChatType;
  count: number;

  @Transform(({ value }) => (value ? plainToInstance(ChatInnerMessageEntity, JSON.parse(value)) : null))
  @Type(() => ChatInnerMessageEntity)
  lastMessage: ChatInnerMessageEntity;

  @Expose({ name: 'memebr_id' })
  memberId: string;

  // For Ui
  groupImageUrl: SafeUrl | string;
  groupId: number;

  get fullName(): string {
    return `${this.name} ${this.lastName || ''}`;
  }
}

export class ChatMessageEntity {
  id: number;
  @Expose({ name: 'room_id' })
  roomId: string;

  @Transform(({ value }) => (value ? plainToInstance(ChatInnerMessageEntity, JSON.parse(value)) : null))
  @Type(() => ChatInnerMessageEntity)
  message: ChatInnerMessageEntity;

  @Expose({ name: 'sender_id' })
  @Transform((item) => +item.value)
  senderId: number;

  @Expose({ name: 'receiver_id' })
  @Transform((item) => +item.value)
  receiverId: number;

  @Expose({ name: 'deleted_by_sender' })
  deletedBySender: number;

  @Expose({ name: 'deleted_by_receiver' })
  deletedByReceiver: number;

  @Expose({ name: 'group_recivers' })
  groupReceiver: any;

  @Expose({ name: 'created_at' })
  createdAt: string;

  @Expose({ name: 'deleted_at' })
  deletedAt: any;

  get isMine(): boolean {
    return this.message.senderUid === +GetUserId();
  }
}

class ChatInnerMessageEntity {
  message: string;
  messageType: ChatMessageType;
  read: boolean;

  @Transform((item) => BeautifyArrayOfNumbers(item.value))
  readers: string[] | number[];

  @Transform(({ value }) => (value ? +JSON.parse(value) : null))
  senderUid: number;

  @Transform(({ value }) => (value ? new Date(value).toISOString() : null))
  timestamp: string;

  @Expose()
  text: { message: string };

  get isMine(): boolean {
    return this.senderUid === +GetUserId();
  }
}

export class ChatMessagePayload {
  file?: File;
  message?: { message: string };
  friendUid: number;
  currentUid: number;
  roomId: string;
}
